import { useEffect } from 'react';
import { useURLSearchParams } from '@shared/hooks/useURLSearchParams';
export const AllOrdersOnly = ({ selectedAccount }: { selectedAccount: string }) => {
  const { urlParams, resetURLSearchParams } = useURLSearchParams();
  useEffect(() => {
    const newParams = {
      account_id: selectedAccount,
    };
    resetURLSearchParams({ ...urlParams, ...newParams });
  }, [urlParams, selectedAccount]);

  return null;
};
